import { render } from "./WorkPolicy.vue?vue&type=template&id=054a0934"
import script from "./WorkPolicy.vue?vue&type=script&lang=js"
export * from "./WorkPolicy.vue?vue&type=script&lang=js"

import "./WorkPolicy.vue?vue&type=style&index=0&id=054a0934&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__